module.exports = __webpack_public_path__ + "media/13.d738ee58.wav";